import type { TypoStyle } from "../../../Typo";

import { CheckIcon } from "../../../Icons";
import { Typo } from "../../../Typo";

type SaveDefaultCheckboxProps = {
  id: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  label: string;
  labelType?: TypoStyle;
  "data-testid"?: string;
};

// Not CheckboxV2: the design draws a 24px box, and CheckboxV2's is 20px.
export const SaveDefaultCheckbox = ({
  id,
  checked,
  onChange,
  label,
  labelType = "bodySM",
  "data-testid": testId,
}: SaveDefaultCheckboxProps) => (
  <label htmlFor={id} className="flex cursor-pointer items-center gap-2">
    <span className="relative flex shrink-0">
      <input
        id={id}
        type="checkbox"
        checked={checked}
        onChange={(event) => onChange(event.target.checked)}
        data-testid={testId}
        className="peer sr-only"
      />
      <span className="flex h-6 w-6 items-center justify-center rounded border border-stroke-primary bg-surface-primary peer-checked:bg-surface-inverse-primary peer-focus-visible:outline peer-focus-visible:outline-2 peer-focus-visible:outline-offset-2 peer-focus-visible:outline-stroke-focused">
        {checked && <CheckIcon className="h-3 w-3 text-text-inverse-primary" />}
      </span>
    </span>
    <Typo element="span" type={labelType} textColor="text-text-primary">
      {label}
    </Typo>
  </label>
);
